import cn from 'clsx'
import s from './ScanningPageDetails.module.scss'
import { FC, useRef } from 'react'
import {
  FullHeightSection,
  Text,
  CustomImage,
  Container,
  Button,
} from '@components/ui'
import { CustomImageProps } from '@components/ui/CustomImage/CustomImage'
import { ScanningPage as ScanningPageType } from '@generated/model/models'
import { BigPlayButton, ControlBar, Player, PlayerReference } from 'video-react'

type ScanningPageProps = {
  data: ScanningPageType
  children?: any
}

const ScanningPageDetails: FC<ScanningPageProps> = ({ data, children }) => {
  return (
    <section className={s.root}>
      <Container>
        <div className={s.textContainer}>
          <Text className={s.detail} html={data.detail} />

          <Text
            variant="sectionHeadingV2"
            className={s.methods}
            html={data.methods}
          />
        </div>
      </Container>
    </section>
  )
}

export default ScanningPageDetails
